// extracted by mini-css-extract-plugin
module.exports = {"input":"Lookup_input_1m4Yc","icon":"Lookup_icon_CSecp"};